//@flow

import * as React from 'react';
import styled from 'styled-components';

const StyledBackLink = styled.p`
  color: #265a9c;
  cursor: ${props => props.active ? "pointer" : "wait"};
  opacity: ${props => props.active ? 1 : 0.5};
  align-self: flex-start;
  margin: 5px 0;
`;

const BackLink = (props: any): React.Node => (
    <StyledBackLink {...props} />
);

export default BackLink;


// WEBPACK FOOTER //
// ./src/components/BackLink.jsx